import frCrtTranslations from './crt.json'
import frCrtAdditionalTranslations from './crt/index'

export { default as frAdmin } from './admin.json'
export { default as frAssortment } from './assortment.json'
export { default as frBanners } from './banners.json'
export { default as frCommon } from './common.json'
export { default as frCredit } from './credit/index'
export { default as frForms } from './forms.json'
export { default as frLaunches } from './launches.json'
export { default as frLogin } from './login.json'
export { default as frMaterials } from './materials.json'
export { default as frOperations } from './operations.json'
export { default as frOrders } from './orders.json'
export { default as frReports } from './reports.json'
export { default as frSoxCompliance } from './sox-compliance.json'
export { default as frStores } from './stores.json'
export { default as frStructural } from './structural.json'
export { default as frUploads } from './uploads.json'
export { default as frWelcome } from './welcome.json'

// The `crt` namespace is assembled from crt.json plus feature files split out of
// it (e.g. crt/bpc-actuals.json). crt.json stays at this level for now to avoid
// churn/merge conflicts;
export const frCrt = { ...frCrtTranslations, ...frCrtAdditionalTranslations }
